export function get_password_validation_errors(password: string): string|undefined {
  if (password.length < 6) {
    return "Password must be at least 6 characters long and contain at least one digit and one special character.";
  }
  const hasNumber = /\d/.test(password);
  const hasSpecialChar = /[_!@#$%^&*(),.?":{}|<> ]/.test(password);
  if (!(hasNumber || hasSpecialChar)) {
    return "Password must contain at least one digit and one special character.";
  }

  return undefined;
}

export function get_login_validation_errors(login: string): string|undefined {
  if (login.length > 25) {
    return "Login must be at most 25 characters long.";
  }

  if (!/^[A-Za-z0-9_ ]+$/.test(login)) {
    return "Login must contain only latin chars, digits or underscores.";
  }

  return undefined;
}